'use client';

import { useContext, useEffect, useState } from 'react';
import { FindOnGlobeContext } from './context';
import { LogoStrokedGradient } from 'assets/icons/LogoStrokedGradient';
import styles from './GlobeLoadingScreen.module.css';

const GlobeLoadingScreen = () => {
  const FGC = useContext(FindOnGlobeContext);
  const [shouldShow, setShouldShow] = useState(false);

  useEffect(() => {
    // Delay showing the loading screen to prevent initial flicker
    const timer = setTimeout(() => {
      setShouldShow(true);
    }, 100);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    // Hide loading screen after stores are loaded and minimum time
    if (FGC.storesLoaded) {
      const timer = setTimeout(() => {
        setShouldShow(false);
      }, 1500);

      return () => clearTimeout(timer);
    }
  }, [FGC.storesLoaded]);

  // Don't render anything if we shouldn't show
  if (!shouldShow) {
    return null;
  }

  return (
    <div className={styles.loadingContainer}>
      <div className={styles.logoContainer}>
        <LogoStrokedGradient style={{ width: '80px', height: '60px' }} />
      </div>
      <div className={styles.loadingText}>Loading...</div>
    </div>
  );
};

export default GlobeLoadingScreen;
